'use client'

import { useEffect } from 'react'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import { LdUser } from '@/types/ldUser'

interface UseLaunchDarklyProps {
  ldUser: LdUser
}

export const useLaunchDarkly = ({ ldUser }: UseLaunchDarklyProps) => {
  const ldClient = useLDClient()

  useEffect(() => {
    if (!ldClient) return
    ldClient.on('error', () => {
      // mute launchdarkly errors
    })
    ldClient.on('failed', () => {
      //  mute launchdarkly errors
    })

    if (ldUser) {
      const merchantId = ldUser?.merchantId
      const merchantDisplayName = ldUser?.merchantDisplayName
      const paymentId = ldUser?.paymentId
      const userId = ldUser?.userId

      if (!merchantId && !merchantDisplayName) return

      const context = {
        kind: 'user',
        key: merchantId,
        name: merchantDisplayName,
        paymentId,
        userId,
      }

      const identify = async () => await ldClient?.identify(context)
      identify()
    }

    return () => {
      if (ldClient) {
        const close = async () => await ldClient?.close()
        close()
      }
    }
  }, [ldClient, ldUser])

  return { ldClient }
}
